<button
  type="button"
  class="filter-chip"
  [class.filter-chip--active]="active()"
  [class.filter-chip--pill]="pill()"
  [attr.aria-pressed]="active()"
  (click)="clicked.emit()"
>
  {{ label() }}
  @if (showCount()) {
    <span class="filter-chip__count" [attr.aria-hidden]="countLabel() ? 'true' : null">{{ count() }}</span>
    @if (countLabel(); as countLabel) {
      <span class="sr-only">{{ countLabel }}</span>
    }
  }
  @if (caret()) {
    <span class="filter-chip__caret" aria-hidden="true">▾</span>
  }
</button>
